import { Grid } from "@mui/material";

import FormOne from "./FormOne";

export default function FormDisplay({
  agencyID,
  multiBrand,
  list,
  editState,
  formikProps,
  setEditState,
  businessEntityID,
}) {
  return (
    <Grid container spacing={4} style={{ padding: "20px" }}>
      <FormOne
        businessEntityID={businessEntityID}
        setEditState={setEditState}
        list={list}
        businessEntityID={businessEntityID}
        agencyID={agencyID}
        multiBrand={multiBrand}
        formikProps={formikProps}
        editState={editState}
      />
    </Grid>
  );
}
